<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Cash Winners</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link to="/lps/cash-winner">Cash Winners</router-link>
      /
      <b>View</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <div class="col-6 text-left">
                <h2 class="card-title mb-3">{{ this.$route.params.event_name }}</h2>
              </div>

            </div>

            <div class="col-lg-6 col-md-6 col-12">
              <!-- <button @click="clickme(index)">clickme</button> -->
              <div class="card mb-4">
                <div class="card-body">
                  <!-- Title -->
                  <div class="row">
                    <div class="col" >
                      <h5 class="mb-2 text-muted">Pending Info</h5>
                      <p
                        class="mb-1 text-30 font-weight-light"
                        style="color: #ac8400"
                      >
                        {{ statistics.pending_info }}
                      </p>
                      <div class="progress mb-1" style="height: 4px">
                        <div
                          class="progress-bar bg-success"
                          style="width: 100%"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div class="col">
                      <h5 class="mb-2 text-muted">Submitted Info</h5>
                      <p
                        class="mb-1 text-30 font-weight-light"
                        style="color: #ac8400"
                      >
                      {{ statistics.submitted_info }}
                      </p>
                      <div class="progress mb-1" style="height: 4px">
                        <div
                          class="progress-bar bg-success"
                          style="width: 100%"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="col">
                      <h5 class="mb-2 text-muted">Paid</h5>
                      <p
                        class="mb-1 text-30 font-weight-light"
                        style="color: #ac8400"
                      >
                        {{ statistics.paid }}
                      </p>
                      <div class="progress mb-1" style="height: 4px">
                        <div
                          class="progress-bar bg-success"
                          style="width: 100%"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="col">
                      <h5 class="mb-2 text-muted">Expired</h5>
                      <p
                        class="mb-1 text-30 font-weight-light"
                        style="color: #ac8400"
                      >
                        {{ statistics.expired }}
                      </p>
                      <div class="progress mb-1" style="height: 4px">
                        <div
                          class="progress-bar bg-success"
                          style="width: 100%"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
              <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
                :class="{ 'change-background': button.status }" @click="onPressBtn(index)" type="button">
                {{ button.name }}
              </button>
            </div>

            <br />

            <div class="row">
              <div class="text-left col-6">
                <json-excel
                  class="btn btn-rounded btn-primary mr-1"
                  style="width: 150px"
                  :fetch="CallBackData"
                  :fields="json_fields"
                  type="csv"
                  worksheet="My Worksheet"
                  name="Cash Prize.csv"
                >
                  Excel
                </json-excel>

              </div>
            </div>

            <br />

            <div class="row">
              <div class="text-left col-6">
                <button
                  class="btn btn-primary mr-1"
                  style="width: 150px"
                  @click="markAsPaid()"
                >
                  Mark as Paid
                </button>
                <br>
                <span style="font-style: italic; color: red">*Note: Available only on Submitted status</span>
              </div>

              <div class="col-6 input-group mb-4 d-flex flex-row-reverse p2">
                <button type="button" class="btn btn-primary mr-1" @click="filterSearch">
                  <i class="fas fa-search"></i>
                </button>
                <div class="form-outline mr-1">
                  <input type="input" class="form-control" v-model="search"/>
                </div>
              </div>
            </div>


            
            <div class="table-responsive">
              <!-- All -->
              <table
                id="vendor_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th width="150">
                      <input class="mr-4 custom-checkbox" type="checkbox" v-model="selectAll" />
                      <span style="text-align: left;">IC Number</span>
                    </th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>IC Photo</th>
                    <th>Bank Photo</th>
                    <th>Bank Details</th>
                    <th>Remarks</th>
                    <th>Remarks By</th>
                    <th>Marked Paid By</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody v-if="people.length < 1">
                  <tr>
                    <td colspan="11">No Data</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr v-for="(person) in people" :key="person.id">
                    <td>
                      <input class="mr-4 custom-checkbox" type="checkbox" :value="person.id" v-model="selectedItems" :disabled="isSubmitted(person)" />
                      <span style="text-align: left;">{{person.ic_number}}</span>
                    </td>
                    <td>{{person.name}}</td>
                    <td>
                      <span :style="{color: checkStatus(person.status), fontWeight: 'bold'}">
                        {{person.status}}
                      </span>
                    </td>
                    <td>
                      <button v-if="person.ic_upload"
                        type="button"
                        class="btn btn-primary btn-block btn-rounded"
                        style="margin-bottom: 20px;"
                        @click="showImage(person, 'ic_upload')"
                        >View Details
                      </button>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <button v-if="person.bank_upload"
                        type="button"
                        class="btn btn-primary btn-block btn-rounded"
                        style="margin-bottom: 20px;"
                        @click="showImage(person, 'bank_upload')"
                        >View Details
                      </button>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <span v-if="person.bank_details">
                        {{ person.account_holder }}
                        <br>
                        {{ person.bank_name }}
                        <br>
                        {{ person.bank_number }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td><span v-html="person.remarks"></span></td>
                    <td>{{person.remarks_by}}</td>
                    <td>{{person.paid_by}}</td>
                    <td>
                      <button
                        type="button"
                        data-toggle="modal"
                        data-target="#resend-modal"
                        class="btn btn-primary btn-block btn-rounded"
                        @click="inputData(person)"
                        style="margin-bottom: 20px;"
                        >Resubmit
                      </button>
                      <button
                        type="button"
                        data-toggle="modal"
                        data-target="#manual-add-modal"
                        @click="inputData(person)"
                        class="btn btn-primary btn-block btn-rounded"
                        style="margin-bottom: 20px;"
                        >Manual Submit
                      </button>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
              <pagination
                v-model="pageInfo.current_page"
                :per-page="pageInfo.per_page"
                :records="pageInfo.total"
                @paginate="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade manual-add-modal" role="dialog" aria-labelledby="myLargeModalLabel"
      aria-hidden="true" id="manual-add-modal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4">
            <b>
              <h4 style="text-align: center; color: #AC8400">Manual Submit</h4>
            </b>

            <span class="text-capitalize text-size">{{ personData.name }}</span>
            <br/>
            <span class="text-capitalize text-size">{{ personData.ic_number }}</span>

            <br/>
            <br/>

            <h5><b>Upload IC</b></h5>

            <div class="row">
              <div class="col-12">
                <input
                  type="file"
                  ref="file"
                  class="inputfile"
                  v-on:change="handleFileUpload"
                />
              </div>
            </div>

            <br />
            <br/>

            <h5><b>Bank Details</b></h5>

            <h5><b>Upload Bank</b></h5>

            <div class="row">
              <div class="col-12">
                <input
                  type="file"
                  ref="bank_file"
                  class="inputfile"
                  v-on:change="handleBankUpload"
                />
              </div>
            </div>

            <br>
            <div class="row mb-2">
              <div class="col-4">
                <span>Account holder's Name</span>
              </div>

              <div class="col-8">
                <input class="form-control" type="text"  v-model="account_holder"/>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4">
                <span>Bank Name</span>
              </div>

              <div class="col-5">
                <select class="form-control" id="dropdown" v-model="selectedOption" >
                  <option v-for="(bank, index) in banks" :key="index" :value="bank">{{ bank }}</option>
                </select>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4">
                <span>Account Number</span>
              </div>

              <div class="col-8">
                <input class="form-control" type="text"  v-model="account_number"/>
              </div>
            </div>

            <span>Remarks</span>
            <textarea class="form-control" v-model="personData.remarks"></textarea>

            <br/>

            <div style="text-align: center">
              <button class="btn mr-1"
                style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
                @click="hideModal('#manual-add-modal')"
              >
                Cancel
              </button>
              <button class="btn"
                style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
                @click="submitManual('#manual-add-modal')"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade resend-modal" role="dialog" aria-labelledby="myLargeModalLabel"
      aria-hidden="true" id="resend-modal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4">
            <b>
              <h4 style="text-align: center; color: #AC8400">Remarks</h4>
            </b>

            <span class="text-capitalize text-size">{{ personData.name }}</span>
            <br/>
            <span class="text-capitalize text-size">{{ personData.ic_number }}</span>

            <br/>
            <br/>

            <span>Remarks</span>
            <textarea class="form-control" v-model="personData.remarks"></textarea>

            <br/>

            <div style="text-align: center">
              <button class="btn mr-1"
                style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
                @click="hideModal('#resend-modal')"
              >
                Cancel
              </button>
              <button class="btn"
                style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
                @click="submitManual('#resend-modal')"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade bank-detail-modal" role="dialog" aria-labelledby="myLargeModalLabel"
      aria-hidden="true" id="bank-detail-modal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4">
            <b>
              <h4 style="text-align: center; color: #AC8400">Bank Details</h4>
            </b>
            <br/>
            <label style="font-weight: bold; margin-right: 10px;">Name: </label>
            <span class="text-capitalize text-size"  style="font-weight: bold;">{{ personData.name }}</span>
            <br/>
            <label style="font-weight: bold; margin-right: 10px;">IC Number: </label>
            <span class="text-capitalize text-size"  style="font-weight: bold;">{{ personData.ic_number }}</span>
            <br/>
            <label style="font-weight: bold; margin-right: 10px;">Bank Name: </label>
            <span class="text-capitalize text-size"  style="font-weight: bold;">{{ bank_details.bank_name }}</span>
            <br/>
            <label style="font-weight: bold; margin-right: 10px;">Bank Number: </label>
            <span class="text-capitalize text-size"  style="font-weight: bold;">{{ bank_details.bank_number }}</span>
            <br/>
            <br/>

          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getRequest, postRequest } from "@/services/RequestService";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

export default {
  name: "cash-winner",
  components: {Pagination, JsonExcel},

  data() {
    return {
      people: [],
      loadApi: `/loyalty/prize/winners/${this.$route.params.event_id}/view`,
      signApi: '?',
      downloadApi: `loyalty/prize/winners/${this.$route.params.event_id}/download`,

      statistics: {
        pending_info: 0,
        submitted_info: 0,
        paid: 0,
        expired: 0
      },

      banks: [],

      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },

      personData: {},

      date_from: null,
      date_to: null,
      search: null,

      json_fields: {
        "IC Number": "ic_number",
        "Name": "name",
        "Status": "status",
        "Remarks": "remarks",
        "Remarks By": "remarks_by",
        "Marked Paid By": "paid_by"
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Pending" },
        { status: false, name: "Submitted" },
        { status: false, name: "Paid" },
        { status: false, name: "Expired" },
      ],

      selectedItems: [],
      selectAll: false,
      selectedOption: 0,

      file: null,
      bank_file: null,
      account_number: '',
      account_holder: '',

      imageUrl: null,

      remarks: '',

      bank_details: {},

      type: 0
    };
  },

  watch: {
    selectedItems: function(newVal, oldVal) {
      console.log('Selected items:', newVal);
      console.log(JSON.stringify(this.selectedItems))
    },

    selectAll: function(newVal, oldVal) {
      if (newVal) {
        // Select all items
        this.selectedItems = this.people
          .filter(person => !this.isSubmitted(person))
          .map(person => person.id);
      } else {
        // Deselect all items
        this.selectedItems = [];
      }
    }
  },

  methods: {
    async loadData() {
      try {
        let res = await getRequest(this.loadApi);

        this.people = res.data.success ? res.data.data.winners : [];
        this.pageInfo = res.data.success ? res.data.data.pagination
        :
        {
          current_page: 1,
          next_page_url: null,
          previous_page_url: null,
          total: 0,
          count: 0,
          per_page: 0,
          last_page: 0
        };

        this.statistics = res.data.success ? res.data.statistics
        :
        {
          pending_info: 0,
          submitted_info: 0,
          paid: 0,
          expired: 0
        };

      } catch (e) {
        console.log(e)
      }
    },

    async loadBanks() {
      
      try {
        let res = await getRequest(`loyalty/prize/winners/banks`);

        this.banks = res.data.success ? res.data.banks : [];

      } catch (e) {
        console.log(e)
      }
    },

    async handlePageChange(page) {
      try {
        let res = await getRequest(this.loadApi +`${this.signApi}page=${page}`);

        this.people =  res.data.data.winners;
        this.pageInfo = res.data.data.pagination;

      } catch (e) {
        console.log(e)
      }

    },

    async submitManual(modal) {
      let backendApi = `/loyalty/prize/winners/${this.personData.id}/manual`;

      const formData = new FormData();
      if(modal == '#resend-modal') {
        formData.append('remarks', this.personData.remarks);
        formData.append('_method', "PATCH");

        this.type = 0;

        backendApi = `loyalty/prize/winners/${this.personData.id}/resend`;
      } else {
        formData.append('ic_upload[]', this.file);
        formData.append('bank_upload[]', this.bank_file);
        formData.append('bank_name', this.selectedOption);
        formData.append('bank_number', this.account_number);
        formData.append('account_holder', this.account_holder);
        formData.append('remarks', this.personData.remarks);

        this.type = 1;

        backendApi = `/loyalty/prize/winners/${this.personData.id}/manual`;
      }
  
      if(this.type == 1 && (this.selectedOption == null || this.selectedOption == '')) {
        return swal({
          title: 'Failed',
          icon: 'error',
          text: 'Please select bank.'
        })
      }

      if(this.type == 1 && (this.account_number == null || this.account_number == '')) {
        return swal({
          title: 'Failed',
          icon: 'error',
          text: 'Please enter your account number.'
        })
      }
      
      if(this.personData.remarks == null || this.personData.remarks == '') {
        return swal({
          title: 'Failed',
          icon: 'error',
          text: 'Please enter your remarks.'
        })
      }

      
      try {
        let res = await postRequest(backendApi, formData);

        swal({
          title: res.data.success ? 'Success' : 'Failed',
          icon: res.data.success ? 'success' : 'error',
          text: res.data.message
        });

        
        if(res.data.success) {
          this.loadData();
          $(modal).modal('hide');
          this.resetForm();
        }

      } catch (e) {
        console.log(e)
      }
    },

    resetForm() {
      this.file = null;
      this.bank_file = null;
      this.selectedOption = '';
      this.account_number = '';
      this.account_holder = '';
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    handleBankUpload() {
      this.bank_file = this.$refs.bank_file.files[0];
    },

    async markAsPaid() {

      if(this.selectedItems.length < 1) {
        return swal({
          icon: 'error',
          title: 'Error',
          text: 'Please tick one of the box.'
        })
      }

      let request = {
        ids: this.selectedItems,
        _method: "PATCH"
      }
      
      try {
        let res = await postRequest('/loyalty/prize/winners/paid', request);

        swal({
          title: res.data.success ? 'Success' : 'Failed',
          icon: res.data.success ? 'success' : 'error',
          text: res.data.message
        });

        if(res.data.success) {
          this.loadData();
        }

      } catch (e) {
        console.log(e)
      }
    },

    async filterDate() {
      this.loadApi = axios.lpsURL +`/award?date_from=${this.date_from}&date_to=${this.date_to}`;
      this.downloadApi = axios.lpsURL +`/award/download?date_from=${this.date_from}&date_to=${this.date_to}`;
      this.signApi = `&`;

      try {
        let res = await getRequest(this.loadApi);

        this.people =  res.data.data.awarded_points;
        this.pageInfo = res.data.data.pagination;

      } catch (e) {
        console.log(e)
      }
    },

    async filterSearch() {
      this.loadApi = `loyalty/prize/winners/${this.$route.params.event_id}/view?search=${this.search}`;
      this.downloadApi = `loyalty/prize/winners/${this.$route.params.event_id}/download?search=${this.search}`
      this.signApi = `&`;

      try {
        let res = await getRequest(this.loadApi);

        this.people = res.data.success ? res.data.data.winners : [];
        this.pageInfo = res.data.success ? res.data.data.pagination
        :
        {
          current_page: 1,
          next_page_url: null,
          previous_page_url: null,
          total: 0,
          count: 0,
          per_page: 0,
          last_page: 0
        };

      } catch (e) {
        console.log(e)
      }
    },

    async CallBackData() {
      // clear json_data
      this.json_data = [];

      let res = await getRequest(this.downloadApi);

      for(let i = 0; i < res.data.data.winners.length; i++) {
        this.json_data.push({
          ic_number: res.data.data.winners[i].ic_number,
          name: res.data.data.winners[i].name,
          status: res.data.data.winners[i].status,
          remarks: res.data.data.winners[i].remarks,
          remarks_by: res.data.data.winners[i].remarks_by,
          paid_by: res.data.data.winners[i].paid_by,
        });
      }

      return this.json_data;
    },

    async getBankDetails(person) {
      this.personData = person;
      try {
        let request = {
          prize_winner: person.id
        };

        let res = await postRequest(`loyalty/prize/winners/details`, request);

        this.bank_details = res.data.success ? res.data.data : {};

      } catch (e) {
        console.log(e)
      }
    },

    async showImage(person, upload_type) {
      let responseType = "";
      let type = "";

      let token = localStorage.getItem("token");
      
      if(token == null) {
        return;
      }
      
      token = JSON.parse(token);
      token = token.access_token;

      try {
        if(person.file_type == 'pdf') {
          responseType = "arraybuffer";
        } else {
          responseType = "blob";
        }

        let res = await axios.post("loyalty/prize/winners/image",
        {
          prize_winner: person.id,
          type: upload_type,
        },
        {
          headers: {
            Authorization: "Bearer " +token,
          },
          responseType: responseType,
        });

        if (responseType == "arraybuffer") {
          type = "application/pdf";
        } else {
          type = "image/x-png, image/gif, image/jpeg, image/jpg";
        }

        let blob = new Blob([res.data], { type: type }),
        url = window.URL.createObjectURL(blob);

        window.open(url);

      } catch (e) {
        console.log(e)
      }
    },

    async toPDF() {
      let datas = await this.CallBackData();

      const new_datas = datas.map(element => Object.values(element));

      let doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
      
      autoTable(doc, {
        head: [['Date Earned', 'Account Number', 'IC Number', 'Name', 'Mobile Number', 'Description', 'Points', 'Expiry Date', 'Awarded By']],
        body: new_datas,
      });

      doc.save("Award Point.pdf");
    },

    async reset() {
      this.date_from = this.date_to = null;
      this.loadData();
    },

    async onPressBtn(int) {
      this.buttons.forEach((button, index) => {
        button.status = int === index;
      });

      this.checkbuttons();

    },

    async checkbuttons() {
      if (this.buttons[0].status) {
        this.signApi = '?';
        this.loadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/view`;
        this.downloadApi = `loyalty/prize/winners/${this.$route.params.event_id}/download`;
      } else if (this.buttons[1].status) {
        this.signApi = '&';
        this.loadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/view?status=0`;
        this.downloadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/download?status=0`;
      } else if (this.buttons[2].status) {
        this.signApi = '&';
        this.loadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/view?status=1`;
        this.downloadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/download?status=1`;
      } else if (this.buttons[3].status) {
        this.signApi = '&';
        this.loadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/view?status=2`;
        this.downloadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/download?status=2`;
      } else {
        this.signApi = '&';
        this.loadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/view?status=3`;
        this.downloadApi = `/loyalty/prize/winners/${this.$route.params.event_id}/download?status=3`;
      }

      this.loadData();
    },

    hideModal(name) {
      $(name).modal('hide');
    },

    async inputData(person) {
      this.resetForm();
      this.personData = person;
    },

    checkStatus(status) {
      switch (status) {
        case 'Pending':
          return 'red';
        case 'Paid':
          return 'blue';
        case 'Submitted':
          return 'green';
        case 'Expired':
          return 'orange';
        default:
          return 'black';
      }
    },

    isSubmitted(person) {
      return person.status !== 'Submitted';
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.loadData();
    await this.loadBanks();
  },

};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}

.custom-checkbox {
  border-color: #ac8400 !important;
}

.text-capitalize {
  text-transform: uppercase !important;
}

.text-size {
  font-size: 14px !important;
}
</style>

<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #AC8400;
  border-color: #AC8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
    background-color: #806200;
    border-color: #b38900;
}
</style>
